import { Button } from "../../../../shadcn/components/ui/button";

export interface ButtonStatesInterface {
  processing: boolean;
  success: boolean;
  error: boolean;
}

interface PropertyDocumentViewListItemPropesInterface {
  documentTitle: string;
  document: any;
  onViewDocument?: (document: any) => void;
  viewDocumentButtonStates?: ButtonStatesInterface;
}

export const PropertyDocumentViewListItem: React.FC<
  PropertyDocumentViewListItemPropesInterface
> = ({
  documentTitle = "Untitled Document Title",
  document = null,
  onViewDocument = () => {},
  viewDocumentButtonStates = {
    processing: false,
    success: false,
    error: false,
  },
}) => {
  return (
    <div className="flex sm:flex-row flex-col sm:justify-between sm:items-center gap-4 p-4 border border-brand-bordersDividerLightGrey rounded-lg">
      <p className="font-medium text-gray-900 text-base line-clamp-2 sm:line-clamp-1">
        {documentTitle}
      </p>

      <Button
        onClick={() => {
          onViewDocument?.(document);
        }}
        variant="outline"
        disabled={viewDocumentButtonStates?.processing}
        className="justify-center bg-transparent hover:bg-gray-100 shadow-none border border-gray-300 w-full sm:w-auto"
      >
        <span className="font-medium text-black">View</span>
      </Button>
    </div>
  );
};
